export default __webpack_public_path__ + "static/media/report@3x.d00a3802.png";